import _ from 'lodash';
import { ValidationProcess, ValidationRuleLevel, ValidationRuleType } from './types';
import { VALIDATION_RULE_GROUP_NOTIFICATION } from './constants';

export const isValidationRulesBlocking = (
  validationRulesByProcess: { [key: string]: ValidationRuleType[] },
  process: ValidationProcess
) => {
  const validationRulesApplicables = _.filter(
    validationRulesByProcess[process] || [],
    (vr) => vr.validationRuleLevel === ValidationRuleLevel.ERROR
  );
  return validationRulesApplicables.length > 0;
};

export const isValidationRulesBlockingForNotification = (validationRulesByProcess: { [key: string]: ValidationRuleType[] }) => {
  const validationRulesApplicables = _.filter(
    validationRulesByProcess[ValidationProcess.SUBMISSION] || [],
    (vr) =>
      // Warning: specific case for AP118 (only rule for notification to block "submit for notification" button)
      // a new category in inconsistencies report is not wanted
      vr.validationRuleLevel === ValidationRuleLevel.ERROR &&
      vr.validationRule === 'AP118' &&
      vr.validationRuleGroup === VALIDATION_RULE_GROUP_NOTIFICATION
  );
  return validationRulesApplicables.length > 0;
};
